import { getBoundedAspectRatio } from './media';

export const getBaseVimeoUrl = (embedLink: string) => {
  const url = new URL(embedLink);
  const queryParams = url.searchParams;
  const hash = queryParams.get('h');
  return `${url.origin}${url.pathname}${hash ? `?h=${hash}` : ''}`;
};

export const getVideoAspectRatio = async (
  // biome-ignore lint/suspicious/noExplicitAny: Automated migration to Biome
  videoElement: Record<string, any>
): Promise<string | null> => {
  try {
    if (videoElement?.options?.host === 'https://www.youtube.com') {
      const videoId = videoElement.options.videoId;
      const oEmbedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}`;

      const { width, height } = await fetch(oEmbedUrl).then((response) =>
        response.json()
      );

      return getBoundedAspectRatio(width, height);
    }

    const [width, height] = await Promise.all([
      videoElement.getVideoWidth(),
      videoElement.getVideoHeight(),
    ]);

    return getBoundedAspectRatio(width, height);
  } catch (error) {
    console.error(error);
    return null;
  }
};
